<div class="fullcontainer">
  <br />
  <br />

  <div class='titleContainer noPrint'>
    <h2 class='header' style='color: #006498'>Stock Movement Labels</h2>

    <div>
      <button class='btn btn-secondary' (click)='this.print()' [disabled]='this.levels.length === 0'>
        <i class="fas fa-print"></i> Print Labels
      </button>&nbsp;
      <button class='btn btn-secondary' (click)='this.continueToStockLevels()'>
        <i class="fas fa-arrow-right"></i> Continue to Stock Levels
      </button>&nbsp;
    </div>
  </div>
  <app-label-print-setup></app-label-print-setup>
  <br />

  @if (this.levels.length === 0) {
    <div class="alert alert-info noPrint">
      No labels to print. This screen only has something to show right after posting a stock
      movement - if you have refreshed the page or navigated here directly, there is nothing to
      print.
    </div>
  }

  <div class='labelSheet'>
    @for (level of this.levels; track level.id) {
      <app-stock-label
        scanType='product'
        [recordId]='level.productId'
        [title]='this.getShelf(level)'
        [subtitle]='this.getProductName(level)'
        [reference]='this.getSku(level)'
      ></app-stock-label>
    }
  </div>
</div>
